import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AuthorizationDocumentDetail,
  getListAuthorizationDocsQueryParams,
} from "core/http/service/authorizationDocument/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  [key: string]: {
    status?: ReduxStateType;
    data?: AuthorizationDocumentDetail[];
    categoryName?: string;
    totalRecords?: number;
  };
}

const initialState: InitialState = {};

const getListAuthorizationDocsSlice = createSlice({
  name: "getListAuthorizationDocs",
  initialState,
  reducers: {
    getListAuthorizationDocsStart: (
      state,
      action: PayloadAction<{
        type: string;
        params?: getListAuthorizationDocsQueryParams;
      }>
    ) => {
      const data = state[action.payload.type]?.data ?? [];
      state[action.payload.type] = {
        status: ReduxStateType.LOADING,
        data,
        totalRecords: 0,
        categoryName: state[action.payload.type]?.categoryName ?? "",
      };
    },
    getListAuthorizationDocsSuccess: (
      state,
      action: PayloadAction<{
        type: string;
        data: AuthorizationDocumentDetail[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state[action.payload.type] = {
        status: ReduxStateType.SUCCESS,
        data: [...state[action.payload.type].data, ...action.payload.data],
        categoryName: action.payload.categoryName,
        totalRecords: action.payload.totalRecords,
      };
    },
    getListAuthorizationDocsFailed: (
      state,
      action: PayloadAction<{ type: string }>
    ) => {
      state[action.payload.type] = {
        status: ReduxStateType.ERROR,
        data: [],
      };
    },
    resetListAuthorizationDocs: (
      state,
      action: PayloadAction<{ type: string }>
    ) => {
      state[action.payload.type] = {};
    },
  },
});

export const {
  getListAuthorizationDocsStart,
  getListAuthorizationDocsSuccess,
  getListAuthorizationDocsFailed,
  resetListAuthorizationDocs,
} = getListAuthorizationDocsSlice.actions;

export default getListAuthorizationDocsSlice.reducer;
